"use client";

import { Children, PropsWithChildren, useEffect, useRef } from "react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from "swiper";

import Box from "@mui/material/Box";
import { IconButton, styled } from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";

interface CarouselProps extends PropsWithChildren {}
const Carousel: React.FC<CarouselProps> = ({ children }) => {
	const swiperRef = useRef<SwiperType>();

	useEffect(() => {
		const handleUpdateSwiper = () => {
			swiperRef.current?.update();
		};
		window.addEventListener("resize", handleUpdateSwiper);
		return () => {
			window.removeEventListener("resize", handleUpdateSwiper);
		};
	}, []);

	return (
		<Box component="div" className="relative explore-carousel">
			<Swiper
				slidesPerView="auto"
				spaceBetween={16}
				observer={true}
				observeParents={true}
				loop={true}
				modules={[Navigation]}
				onSwiper={(swiper) => {
					swiperRef.current = swiper;
				}}
				className="!overflow-visible"
			>
				{Children.map(children, (child, _index) => (
					<SwiperSlide key={_index} className="box-border w-full max-w-[250px]">
						{child}
					</SwiperSlide>
				))}
			</Swiper>
			<Box
				component="div"
				className="flex justify-between items-center w-fit px-0 z-10 absolute bottom-0 translate-y-[150%] right-0"
			>
				<IconButton
					className="w-10 h-10 justify-center items-center pointer-events-auto"
					onClick={() => swiperRef.current?.slidePrev()}
				>
					<Iconify width={24} icon="solar:arrow-left-outline" />
				</IconButton>
				<IconButton
					onClick={() => swiperRef.current?.slideNext()}
					className="w-10 h-10 justify-center items-center pointer-events-auto"
				>
					<Iconify width={24} icon="solar:arrow-right-outline" />
				</IconButton>
			</Box>
		</Box>
	);
};
export default Carousel;
